<script setup>
import {Doughnut} from "vue-chartjs";
import {ArcElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from 'chart.js'
import {computed} from "vue";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale)

const props = defineProps({
  chartLabels: Array,
  dataValues: Array
})

const chartData = computed(() => {
  return {
    chartLabels: props.chartLabels,
    datasets: [{
      data: props.dataValues,
      backgroundColor: ['#222051', '#554e72', '#8e859f', '#d9d6de', '#81236c', '#9c5f8b', '#bd98b2', '#e9dee6', '#0d6d80', '#458a9c', '#8eb1bd', '#636466', '#acaeb1', '#474749'],
      borderWidth: 0,
      datalabels: {
        display: false
      }
    }],
  }
})
const chartOptions = {
    title: {
      display: false
    },
    animation: {
      animateScale: true,
      animateRotate: true
    },
    layout: {
      padding: 30
    },
    plugins: {
      legend: {
        display: false
      },
      tooltips: {
        enabled: false,
      },
    },
    responsive: true,
    maintainAspectRatio: true
  }
</script>

<template>
  <Doughnut :data="chartData" :options="chartOptions">
  </Doughnut>
</template>
